export default function ConditionalRender({ condition, children }) {
  if (condition) {
    return children;
  }

  return null;
}
